import StatusTag from "../../components/StatusTag";

// Maps a stock-transfer lifecycle status to a StatusTag colour + a human label.
// Backend statuses: draft | in_transit | received | cancelled.
export function statusColor(status) {
  switch(status) {
    case "draft": return StatusTag.COLORS.GREY;
    case "in_transit": return StatusTag.COLORS.BLUE;
    case "received": return StatusTag.COLORS.GREEN;
    case "cancelled": return StatusTag.COLORS.RED;
    default: return StatusTag.COLORS.OUTLINE;
  }
}

export function statusLabel(status) {
  switch(status) {
    case "draft": return "Draft";
    case "in_transit": return "In Transit";
    case "received": return "Received";
    case "cancelled": return "Cancelled";
    default: return status;
  }
}

export function shortenDate(val) {
  if (!val) return "";
  return val.substring(0, 10);
}
